'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  // A directive to handle user event tracking on specific DOM element clicks
  // Takes in a `gaEvent` object to send to Google Analytics for event tracking.
  // Additional objects attached to this event will only be send to our DB thoruhg AuditSvc.

  // gaEvent must be a string in the form [eventCategory].[eventAction].[eventLabel].[eventValue]

  angular.module('msCore').directive('msEtClick', msEtClick);

  msEtClick.$inject = ['eventTrackingSvc', '$parse'];

  function msEtClick(eventTrackingSvc, $parse) {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        element.bind('click', function (e) {
          var parsedEvent = $parse(attr.msEtClick, null, true)(scope);
          var modifierKeys = {
            alt: e.altKey,
            shift: e.shiftKey,
            ctrl: e.ctrlKey,
            meta: e.metaKey
          };
          // Pick only the keypresses that were true.
          var modifierKeypresses = _.pickBy(modifierKeys, _.identity);
          var additionalData = _.merge(_.omit(parsedEvent, 'gaEvent'), modifierKeypresses);

          if (_.isString(parsedEvent.gaEvent)) {
            parsedEvent = parsedEvent.gaEvent.split('.');
          }
          eventTrackingSvc.fireEvent.apply(eventTrackingSvc, _toConsumableArray(parsedEvent).concat([additionalData]));
        });
      }
    };
  }
})();